import React, { FC } from 'react'
import styles from './_.module.css'

type Props = {
  includeMaxWidthContainer?: boolean
}

export const BodyWrap: FC<Props> = ({ children, includeMaxWidthContainer }) => (
  <div className={styles.bodyWrap}>
    {includeMaxWidthContainer ? (
      <div className={styles.bodyChildWrap}>{children}</div>
    ) : (
      children
    )}
  </div>
)
